import * as d3 from 'd3';
import * as r2p from 'rows2prose';


function insertVexprVisual(id, tableJson) {
  const container = document.getElementById(id);

  let onTableLoadedFunctions = [];

  let table, iConfig, nConfigs;

  [".mean"].forEach(selector => {
    const element = d3.select(container).selectAll(selector),
          keys = element.nodes().map(e => e.getAttribute("data-key"));

    onTableLoadedFunctions.push(() => {
      const globalMin = d3.min(keys, k => d3.min(table[k])),
            globalMax = d3.max(keys, k => d3.max(table[k])),
            min = globalMin,
            // Need a valid scale, so these need to be different.
            max = (globalMin != globalMax)
            ? globalMax
            : globalMax + 1;  // Visualize each point as a low value.

      element
        .data(keys.map(k => {
          const values = table[k],
                [min, max] = d3.extent(values);
          return { values, iConfigs: iConfig, nConfigs, min, max };
        }))
        .call(r2p.scalarDistributionListView()
              .scale(d3.scaleLinear().domain([min, max]).range([0, 215]))
              .useDataMin(true)
              .useDataMax(true)
              .pointRadius(1)
              .height(35)
              .fontSize("13px"));
    });
  });

  [".scale"].forEach(selector => {
    const element = d3.select(container).selectAll(selector),
          keys = element.nodes().map(e => e.getAttribute("data-key"));

    onTableLoadedFunctions.push(() => {
      const globalMin = 0,
            globalMax = d3.max(keys, k => d3.max(table[k])),
            min = globalMin,
            // Need a valid scale, so these need to be different.
            max = (globalMin != globalMax)
            ? globalMax
            : globalMax + 1;  // Visualize each point as a low value.

      element
        .data(keys.map(k => {
          const values = table[k],
                [min, max] = d3.extent(values);
          return { values, iConfigs: iConfig, nConfigs, min, max };
        }))
        .call(r2p.scalarDistributionListView()
              .scale(d3.scaleLinear().domain([min, max]).range([0, 215]))
              .useDataMax(true)
              .pointRadius(1)
              .height(35)
              .fontSize("13px"));
    });
  });

  [".mixing_weight"].forEach(selector => {
    const element = d3.select(container).selectAll(selector),
          keys = element.nodes().map(e => e.getAttribute("data-key"));

    onTableLoadedFunctions.push(() => {
      const min = 0,
            max = 1;

      element
        .data(keys.map(k => {
          const values = table[k],
                [min, max] = d3.extent(values);
          return {values, iConfigs: iConfig, nConfigs, min, max };
        }))
        .call(r2p.scalarDistributionListView()
          .scale(d3.scaleLinear().domain([min, max]).range([0, 100]))
          .pointRadius(1)
          .height(35)
          .fontSize("13px"));
    });
  });

  (function() {
    const element = d3.select(container).selectAll(".noise"),
          keys = element.nodes().map(e => e.getAttribute("data-key"));

    onTableLoadedFunctions.push(() => {
      const globalMin = d3.min(keys, k => d3.min(table[k])),
            globalMax = d3.max(keys, k => d3.max(table[k])),
            min = globalMin,
            // Need a valid scale, so these need to be different.
            max = (globalMin != globalMax)
            ? globalMax
            : globalMax * 10;  // Visualize each point as a low value.

      element
        .data(keys.map(k => {return { values: table[k], iConfigs: iConfig, nConfigs, min, max }; }))
        .call(r2p.scalarDistributionListView()
          .scale(d3.scaleLog().domain([min, max]).range([0, 215]))
          .useDataMin(true)
          .useDataMax(true)
          .exponentFormat(true)
          .pointRadius(1)
          .height(35)
          .fontSize("13px"));
    });
  })();

  table = r2p.parseColumns(JSON.parse(tableJson));
  iConfig = table["i_config"];
  nConfigs = d3.max(iConfig) + 1;
  onTableLoadedFunctions.forEach(onloaded => onloaded());
}

function extractRows(arr, iRows) {
  let selected = arr.slice(0, iRows.length);
  iRows.forEach((iRow, i) => {
    selected[i] = arr[iRow];
  });
  return selected;
}

function insertVexprTimeline(id, tableJson) {
  let renderRowsFunctions = [],
      renderTimeFunctions = [],
      onTableLoadedFunctions = [];

  let table, sortedUniqueTimesteps;

  const container = document.getElementById(id),
        timeStateComponent = r2p.hiddenTimeState()
        .renderTimestep(t => {
          const iTimestep = table["i_timestep"];

          let iRows = [];
          for (let i = 0; i < iTimestep.length; i++) {
            if (iTimestep[i] == t) {
              iRows.push(i);
            }
          }

          renderRowsFunctions.forEach(render => render(iRows));
        })
        .renderTime((sortedUniqueTimesteps, index) => {
          renderTimeFunctions.forEach(render => render(sortedUniqueTimesteps, index));
        });

  (function() {
    const element = container.querySelectorAll(".timesteps")[0],
          component = r2p.timeControl()
          .onupdate(iTimestep => {
            d3.select(container).select(".timeState").node()._r2pState.selectTimestep(
              iTimestep
            );
          });

    renderTimeFunctions.push(function(sortedUniqueTimesteps, index) {
      d3.select(element).datum({sortedUniqueTimesteps, index}).call(component);
    });
  })();

  [".mean"].forEach(selector => {
    const element = d3.select(container).selectAll(selector),
          keys = element.nodes().map(e => e.getAttribute("data-key"));

    let component;
    onTableLoadedFunctions.push(() => {
      const globalMin = d3.min(keys, k => d3.min(table[k])),
            globalMax = d3.max(keys, k => d3.max(table[k])),
            min = globalMin,
            // Need a valid scale, so these need to be different.
            max = (globalMin != globalMax)
            ? globalMax
            : globalMax + 1;  // Visualize each point as a low value.
      component = r2p.scalarDistributionView()
        .scale(d3.scaleLinear().domain([min, max]).range([0, 215]))
        .height(12)
        .fontSize(13);
    });

    renderRowsFunctions.push(function (iRows) {
      element
        .data(keys.map(k => extractRows(table[k], iRows)))
        .call(component);
    });
  });

  [".scale"].forEach(selector => {
    const element = d3.select(container).selectAll(selector),
          keys = element.nodes().map(e => e.getAttribute("data-key"));

    let component;
    onTableLoadedFunctions.push(() => {
      const globalMin = 0,
            globalMax = d3.max(keys, k => d3.max(table[k])),
            min = globalMin,
            // Need a valid scale, so these need to be different.
            max = (globalMin != globalMax)
            ? globalMax
            : globalMax + 1;  // Visualize each point as a low value.
      component = r2p.scalarDistributionView()
        .scale(d3.scaleLinear().domain([min, max]).range([0, 215]))
        .useDataMax(true)
        .height(12)
        .fontSize(13);
    });

    renderRowsFunctions.push(function (iRows) {
      element
        .data(keys.map(k => extractRows(table[k], iRows)))
        .call(component);
    });
  });

  [".mixing_weight"].forEach(selector => {
    const element = d3.select(container).selectAll(selector),
          keys = element.nodes().map(e => e.getAttribute("data-key"));

    let component;
    onTableLoadedFunctions.push(() => {
      const min = 0,
            max = 1;
      component = r2p.scalarDistributionView()
        .scale(d3.scaleLinear().domain([min, max]).range([0, 100]))
        .height(12)
        .fontSize(13);
    });

    renderRowsFunctions.push(function (iRows) {
      element
        .data(keys.map(k => extractRows(table[k], iRows)))
        .call(component);
    });
  });

  (function() {
    const element = d3.select(container).selectAll(".noise"),
          keys = element.nodes().map(e => e.getAttribute("data-key"));

    let component;
    onTableLoadedFunctions.push(() => {
      const globalMin = d3.min(keys, k => d3.min(table[k])),
            globalMax = d3.max(keys, k => d3.max(table[k])),
            min = globalMin,
            // Need a valid scale, so these need to be different.
            max = (globalMin != globalMax)
            ? globalMax
            : globalMax * 10;  // Visualize each point as a low value.
      component = r2p.scalarDistributionView()
        .scale(d3.scaleLog().domain([min, max]).range([0, 215]))
        .exponentFormat(true)
        .height(12)
        .fontSize(13);
    });

    renderRowsFunctions.push(function (iRows) {
      element
        .data(keys.map(k => extractRows(table[k], iRows)))
        .call(component);
    });
  })();


  table = r2p.parseColumns(JSON.parse(tableJson))
  sortedUniqueTimesteps = table["i_timestep"]
    .sort(d3.ascending).filter((d, i, a) => !i || d != a[i - 1]);
  onTableLoadedFunctions.forEach(onloaded => onloaded());

  d3.select(container).datum(sortedUniqueTimesteps).call(timeStateComponent);
}


function fetcher(insertVisual) {
  function fetchAndCall(filePath, containerId, preContainerId, contentId, extraWidthHack) {
    const loadingMsg = d3.select(document.getElementById(containerId)).append('div')
      .attr('class', 'loadingMsg')
      .style('position', 'absolute')
      .style('top', '0px')
      .style('left', '0px')
      .style('height', '100%')
      .style('width', '100%')
      .style('background-color', 'rgba(0,0,0,0.8)')
      .style('color', 'white')
      .style('text-align', 'center')
      .style('letter-spacing', '1ex')
      .style('font-size', '48px')
      .style('font-weight', 'bold')
      .style('font-family', 'monospace')
      .call(div => div.append('div')
        .style("margin-top", "30px")
        .text('fetching data...'));

    function adjustScale() {
      const preContainer = document.getElementById(preContainerId);
      const content = document.getElementById(contentId);

      // Calculate the scale factor
      const scale = preContainer.clientWidth / (content.scrollWidth + extraWidthHack);

      // Apply the scale transformation
      content.style.transform = `scale(${scale})`;
      content.style.transformOrigin = 'top left';

      const scaledHeight = content.scrollHeight * scale;
      preContainer.style.height = `${scaledHeight}px`;
    }

    // Adjust scale on window resize
    window.addEventListener('resize', adjustScale);

    fetch(filePath, {method: 'GET', credentials: 'include', mode: 'no-cors'})
      .then(response => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return response.text();
        })
        .then(data => {
          insertVisual(containerId, data);
          loadingMsg.remove();
          adjustScale();
        });
  }

  return fetchAndCall;
}

const fetchAndInsertVisual = fetcher(insertVexprVisual);
const fetchAndInsertTimeline = fetcher(insertVexprTimeline);

export {fetchAndInsertVisual, fetchAndInsertTimeline};
